// @ts-ignore
import { useMatches, useNavigate } from 'react-router-dom'
import { useAuth, useGuard, useHasAccess } from '../../hooks/auth'
import { LOCAL_EXECUTION } from '../../utils/featureFlag'
import {
  DashboardhMediumButton,
  Modal,
  DashboardAccountTable,
  DashboardMessage,
} from 'bd-web-components'
import { closeButtonIcon } from '../../components/Icon/iconsImport'
import { IconProducer } from '../../components/Icon/index'
import {
  Container,
  FormDivider,
  CloseButton,
  ModalSubText,
  ModalTitle,
  ModalContainerTop,
  ModalContainerBottom,
  Space,
  TextHeaderBox,
  PageTitle,
  PageHeaderBox,
  PageSubtitle,
  ButtonHeaderBox,
  TableContainer,
  ExceptionContainer,
} from './styles'
import { useCallback, useEffect, useState } from 'react'
import {
  deleteBankAccountRequest,
  IBankAccountProps,
} from '../../Service/accounts'
import Loader from '../../components/Loader'
// @ts-ignore
import { toast } from 'react-toastify'
import { useUserBankAccounts } from '../../hooks/account'
import { onlyCpjCNPJvalid } from '../../utils/onlyValidAccounts'
import { Breadcrumb } from '../../components/Breadcrumb'
import { getDashColor } from '../../styles'

export function BankAccounts() {
  const authContext = useAuth()
  const { authHookWithOutEvent, cookies } = authContext
  const navigate = useNavigate()

  if (!LOCAL_EXECUTION) {
    authHookWithOutEvent()
  }

  useGuard(['DP5'])

  const screenLimit = 762
  const [screenWidth, setScreenWidth] = useState(window.innerWidth)
  const [isMobile, setIsMobile] = useState<boolean>(screenWidth < screenLimit)

  const userAccountsObject = useUserBankAccounts()

  let matches = useMatches()
  let crumbs = matches
    .filter((match: any) => Boolean(match.handle?.crumb))
    .map((match: any) => {
      return {
        name: match.handle.crumb(match.data),
        path: match.pathname,
      }
    })

  const authToken = LOCAL_EXECUTION
    ? process.env.REACT_APP_LOCAL_EXECUTION_TOKEN
    : cookies.userJWT

  const accessAddAccount = useHasAccess('DP5')

  const [accounts, setAccounts] = useState<IBankAccountProps[] | null>(null)
  const [modalControl, setModalControl] = useState<boolean>(false)
  const [idToDelete, setIdToDelete] = useState<string>('')
  const [reload, setReload] = useState<boolean>(true)
  const [loading, setLoading] = useState<boolean>(false)
  const [isError, setIsError] = useState<boolean>(false)
  const spaceValue = isMobile ? 140 : 40

  const handleWindowSizeChange = useCallback(() => {
    setScreenWidth(window.innerWidth)
  }, [])

  const handlerDelete = async (event: any) => {
    setLoading(true)
    setModalControl(true)
    const payloadId = idToDelete
    const deleteBankAccountResponse: boolean = await deleteBankAccountRequest(
      authToken,
      payloadId
    )
    if (deleteBankAccountResponse) {
      toast.success('Conta deletada com sucesso!')
      setLoading(false)
      setReload(!reload)
      setModalControl(false)
    }
    if (!deleteBankAccountResponse) toast.error('Um erro aconteceu ao deletar')
  }

  const handlerNavigate = (url: string) => {
    navigate(url)
  }

  const handlerModal = (accountId: string) => {
    if (typeof accountId === 'string') setIdToDelete(accountId)
    setModalControl(!modalControl)
  }

  useEffect(() => {
    if (userAccountsObject.accounts !== undefined) {
      const data = userAccountsObject.accounts.data.data
      if (data !== null) {
        setAccounts(data)
      } else {
        setIsError(true)
      }
    }
  }, [userAccountsObject])

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange)
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [handleWindowSizeChange])

  useEffect(() => {
    setIsMobile(screenWidth < screenLimit)
  }, [accounts, screenWidth])

  const filteredAccounts = onlyCpjCNPJvalid(accounts)

  return (
    <>
      <Container>
        <Breadcrumb paths={crumbs} />
        <PageHeaderBox>
          <TextHeaderBox>
            <PageTitle>{'Contas Bancárias'}</PageTitle>
            <PageSubtitle>
              {`Nesta página ficam as contas bancárias cadastradas. Visualize cada uma e
            edite-as quantas vezes precisar.`}
            </PageSubtitle>
          </TextHeaderBox>
          <ButtonHeaderBox>
            {accessAddAccount && (
              <DashboardhMediumButton
                onClick={() => handlerNavigate('/finance/add-account')}
                color="#fff"
                background={getDashColor('SECONDARY_BLUE_01', 'GRAY_DARK')}
                height="48px"
                maxWidth="100%"
                variant="contained"
                width="204px"
                borderRadius='100px'
              >
                {'Cadastrar Nova Conta'}
              </DashboardhMediumButton>
            )}
          </ButtonHeaderBox>
        </PageHeaderBox>
        <FormDivider />
        <div>
          {isError && (
            <ExceptionContainer height={400} margin={false}>
              <DashboardMessage
                isError={true}
                isImage={true}
                maintext={'Um erro aconteceu...'}
                subtext={'Já estamos trabalhando para corrigir o problema'}
              />
            </ExceptionContainer>
          )}
          {filteredAccounts !== null && !isError && (
            <TableContainer
              height={filteredAccounts.length * spaceValue}
              margin={true}
            >
              <DashboardAccountTable
                data={filteredAccounts}
                handlerDelete={handlerModal}
              />
            </TableContainer>
          )}
          {filteredAccounts === null && !isError && (
            <ExceptionContainer height={400} margin={false}>
              <Loader />
            </ExceptionContainer>
          )}
        </div>
        <Modal isShowing={modalControl}>
          <ModalContainerTop>
            <div>
              <ModalTitle>{'Deseja excluir conta bancária?'}</ModalTitle>
              <ModalSubText>
                {
                  'Ao excluir, a conta some da lista. Para reativar, adicione-a novamente com as informações necessárias.'
                }
              </ModalSubText>
            </div>
            <div>
              <CloseButton
                // @ts-ignore
                onClick={handlerModal}
                type="button"
              >
                <IconProducer src={closeButtonIcon} />
              </CloseButton>
            </div>
          </ModalContainerTop>
          <ModalContainerBottom>
            <DashboardhMediumButton
              // @ts-ignore
              onClick={handlerModal}
              height="52px"
              maxWidth="100%"
              variant="outlined"
              width="133px"
            >
              {'Cancelar'}
            </DashboardhMediumButton>
            <Space />
            <DashboardhMediumButton
              // @ts-ignore
              onClick={handlerDelete}
              disable={loading}
              color="#fff"
              height="52px"
              maxWidth="100%"
              variant={loading ? 'disabled' : 'contained'}
              width="100%"
            >
              {!loading && <>{'Confirmar'}</>}
              {loading && <Loader small={true} />}
            </DashboardhMediumButton>
          </ModalContainerBottom>
        </Modal>
      </Container>
    </>
  )
}
